
export default [
  {
    path: "/qspiQBRPlan",
    name:"qbrPlan",
    component: () =>
      import("@/components/page/QSPI/QBR/QbrPlan"),
    meta: { title: "QBR计划" },
  },
  {
    path: "/qspiQBRPlan/detail",
    name:"qbrPlanDetail",
    component: () =>
      import("@/components/page/QSPI/QBR/MaintainceQbrPlan"),
    meta: { title: "QBR计划维护" },
  },
  {
    path: "/qspiQBR",
    name:"qbr",
    component: () => import("@/components/page/QSPI/QBR/QueryQbr"),
    meta: { title: "QBR" },
  },
  {
    path: "/qspiQBR/detail",
    name:"qbrDetail",
    component: () => import("@/components/page/QSPI/QBR/MaintainceQbr"),
    meta: { title: "维护QBR" },
  },
  {
    path: "/qspiQBR/rateHistoryVersion",
    name:"rateHistoryVersion",
    component: () => import("@/components/page/QSPI/QBR/rateHistoryVersion"),
    meta: { title: "QBR Performance" },
  },
];
